import { __decorate, __extends, __spreadArrays } from "tslib";
import { Cell, Checkbox } from 'wix-style-react';
import * as React from 'react';
import { withTranslation } from '../../../component-decorators/with-translation';
var SelectorCheckBoxMobile = /** @class */ (function (_super) {
    __extends(SelectorCheckBoxMobile, _super);
    function SelectorCheckBoxMobile(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubCategoriesCheck = function () {
            var _a = _this.props, subCategory = _a.subCategory, subCategoriesCount = _a.subCategoriesCount, setCheckedSubCategories = _a.setCheckedSubCategories, checkedSubCategories = _a.checkedSubCategories;
            var subCategories = checkedSubCategories || [];
            var selectedAllSubCategories = !subCategory ||
                (!subCategories.includes(subCategory) &&
                    subCategories.length + 1 === subCategoriesCount);
            if (selectedAllSubCategories) {
                subCategories = [];
            }
            else {
                subCategories = _this.wasSubCategoryChecked()
                    ? subCategories.filter(function (sub) { return sub.slug !== subCategory.slug; })
                    : __spreadArrays(subCategories, [subCategory]);
                subCategories = subCategories.length ? subCategories : [];
            }
            setCheckedSubCategories(subCategories);
        };
        _this.wasSubCategoryChecked = function () {
            var _a = _this.props, subCategory = _a.subCategory, subCategoriesCount = _a.subCategoriesCount, checkedSubCategories = _a.checkedSubCategories;
            var subCategories = checkedSubCategories || [];
            return !subCategory
                ? subCategories.length === 0 ||
                    subCategories.length === subCategoriesCount
                : subCategories.find(function (sub) { return sub.slug === subCategory.slug; }) &&
                    subCategories.length !== subCategoriesCount;
        };
        _this.onSubCategoriesCheck = _this.onSubCategoriesCheck.bind(_this);
        _this.wasSubCategoryChecked = _this.wasSubCategoryChecked.bind(_this);
        return _this;
    }
    SelectorCheckBoxMobile.prototype.render = function () {
        var _this = this;
        var _a = this.props, subCategory = _a.subCategory, t = _a.t;
        return (React.createElement(Cell, null,
            React.createElement(Checkbox, { checked: this.wasSubCategoryChecked(), onChange: function () { return _this.onSubCategoriesCheck(); } }, subCategory
                ? subCategory.name
                : t('category.filter-subcategory.all'))));
    };
    SelectorCheckBoxMobile = __decorate([
        withTranslation
    ], SelectorCheckBoxMobile);
    return SelectorCheckBoxMobile;
}(React.Component));
export { SelectorCheckBoxMobile };
//# sourceMappingURL=selector-checkbox-mobile.js.map